import FormikAutocompleteField from './FormikAutocompleteField';

export default FormikAutocompleteField;
